import { render, staticRenderFns } from "./CompanyBoard.vue?vue&type=template&id=3135cc43&"
import script from "./CompanyBoard.vue?vue&type=script&lang=js&"
export * from "./CompanyBoard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBoard.vue?vue&type=style&index=0&id=3135cc43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports